import React, { memo, useState } from 'react';

import { Handle } from 'react-flow-renderer';
import './if.css'
import diamond from '../img/diamond.png';
import ifimg from '../img/if.png';
import yes from '../img/yes.png';
import no from '../img/no.png';
import DesignCard from './DesignCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

const IFNodeStyle = {
  // background: 'tan',
  // color: 'purple',
  border: '1px solid #222138',
  textAlign: 'center',
  width: 50,
};


const flowStyle =
{
  display:'flex',
}


export default memo(({ data }) => {
  const [name, setName] = useState();
  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, #a1a1a1, royalblue)', color:'white', padding:'5px', borderRadius:'20px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
  }

  return (
    <div className='designnode'>
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img draggable={false} src={diamond} width='50' height='50' ></img> */}
      <FontAwesomeIcon icon={faQuestionCircle} style={designerIconStyle} size='1x'/>

      <DesignCard attributes={data.attributes} name={data.label}/>

      {/* <Handle
        type="source"
        position="right"
        id="ifno"
        style={{ background: '#555' }}
      />
      <Handle
        type="source"
        position="left"
        id="ifyes"
        style={{ background: '#555' }}
      /> */}

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />


      {/* <Handle
        type="source"
        position="left"
        id="x1"
        style={{ bottom: '35%', top: 'auto', background: '#555' }}
      />
      <h4>{data.label}</h4>

      <Handle
        type="source"
        position="right"
        id="x2"
        style={{ bottom: '35%', top: 'auto', background: '#555' }}
      />
 */}


    </div>
  );
});